import React, { useContext, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Swal from 'sweetalert2';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { suspisiousLisitingRequest, deleteSuspisious, blockUser, blockAd } from './redux/suspisiousDispatcher';
import { imageBaseUrls } from '../../constant/ApiUrls';
import placeholderImage from "../../components/assets/image/placeholder.png";
import { AdminContext } from '../../context/AdminContext';

function SuspisiousListingTable() {
  const { setUnreadSuspiciousActivity } = useContext(AdminContext);

  const dispatch = useDispatch();
  const location = useLocation();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { suspisiousListing, totalSuspisious, loading } = useSelector(
    state => state.suspiciousReducer
  );

  const handleView = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to delete this suspicious activity?`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const messages = JSON.parse(row.messages || '[]');
          const activityIds = messages.map(msg => msg.activity_id).filter(Boolean);

          if (activityIds.length > 0) {
            dispatch(deleteSuspisious(activityIds));
          }
        } catch (error) {
          console.error("Invalid JSON in messages", error);
        }
      }
    });
  };



  const handleBlockUser = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to ${row.user_status === 1 ? "Block" : "Unblock"} "${row.user_name}"`,
      showCancelButton: true,
      confirmButtonText: `Yes, ${row.user_status === 1 ? "Block" : "Unblock"}`,
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(blockUser(row.user_id));

      }
    });
  };


  const handleBlockAd = (adId, adTitle) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to ${"Block"} Ad-"${adTitle}"`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Block',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        var data = {
          id: adId,
          status: 3,
        };
        dispatch(blockAd(data));
      }
    });
  };

  const columns = [
    {
      field: "id",
      headerName: "No",
      width: 70,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + page * pageSize,
    },
    {
      field: "user_image",
      headerName: "Image",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <img
          src={params.value ? `${imageBaseUrls(params.value)}` : placeholderImage}
          alt="Profile"
          style={{ width: 60, height: 60, borderRadius: "10px" }}
        />
      ),
    },
    { field: "user_name", headerName: "User", width: 150 },
    { field: "user_email", headerName: "Email", width: 200 },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <div style={{
          display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
          height: "100%"
        }}>
          <button
            onClick={() => handleView(params.row)}
            style={{
              backgroundColor: "#1b87f4",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",
              padding: "2px 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            View
          </button>

          <button
            onClick={() => handleBlockUser(params.row)}
            style={{
              backgroundColor: "#000000",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",
              padding: "2px 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.row.user_status === 1 ? "Block User" : "Unblock User"}
          </button>

          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",
              padding: "2px 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(suspisiousLisitingRequest(page + 1, pageSize));
    setUnreadSuspiciousActivity(0);
  }, [dispatch, page, pageSize, location.pathname,setUnreadSuspiciousActivity]);
  return (
    <>
      <Paper sx={{ height: "95%", width: '100%' }}>
        <DataGrid
          rows={suspisiousListing || []}
          columns={columns}
          rowCount={totalSuspisious || 0}
          paginationModel={{ page, pageSize }}
          paginationMode="server"
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50]}
          loading={loading}
          rowHeight={80}
          disableRowSelectionOnClick
          sx={{ border: 0 }}
          getRowId={(row) => `${row.user_id}`} // ensure unique ID
        />
      </Paper>

      {/* Dialog to show ad and reasons */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Suspicious Ads & Reasons</DialogTitle>
        <DialogContent dividers>
          {selectedRow && (() => {
            let ads = [];
            let messages = [];

            try {
              ads = JSON.parse(selectedRow.ads || "[]");
              messages = JSON.parse(selectedRow.messages || "[]");
            } catch (e) {
              console.error("Parsing failed", e);
            }

            return ads.map((ad, index) => {
              const adReasons = messages
                .filter(msg => msg.ad_id === ad.ad_id)
                .map(msg => msg.reasons);

              let adImages = [];
              try {
                adImages = JSON.parse(ad.ad_images || "[]");
              } catch (_) { }

              return (
                <div
                  key={index}
                  style={{
                    marginBottom: "24px",
                    padding: "16px 20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
                    backgroundColor: "#fafafa",
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-start",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  {/* Ad Image */}
                  <img
                    src={adImages[0] ? `${imageBaseUrls(adImages[0])}` : placeholderImage}
                    alt="Ad"
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 12,
                      objectFit: "cover",
                      border: "1px solid #dcdcdc",
                    }}
                  />

                  {/* Ad Content */}
                  <div style={{ flex: 1 }}>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginTop: "5px",
                      }}
                    >
                      {ad.ad_title}
                    </h3>
                    {ad.report_count > 0 && (
                      <div style={{ fontSize: "13px", color: "#e53935", marginBottom: "8px", marginTop: "4px" }}>
                        🚩 {ad.report_count} {ad.report_count === 1 ? "report" : "reports"}
                      </div>
                    )}


                    {/* Reasons as a List */}
                    <ul style={{ paddingLeft: "18px", marginTop: 0, color: "#444" }}>
                      {adReasons.map((reason, i) => (
                        <li key={i} style={{ fontSize: "14px", marginBottom: "3px" }}>
                          {reason}
                        </li>
                      ))}
                    </ul>

                    {/* Block Ad Button */}

                    {
                      selectedRow.user_id === ad.ad_user_id && ad.ad_status !== 3 && <button
                        onClick={() => {
                          setOpenDialog(false);
                          handleBlockAd(ad.ad_id, ad.ad_title)

                        }}
                        style={{
                          backgroundColor: "#000000",
                          color: "white",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "10px",
                          width: "120px",
                          height: "24px",
                          padding: "2px 5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {"Block Ad"}
                      </button>
                    }

                  </div>
                </div>
              );
            });
          })()}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary" variant="outlined">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SuspisiousListingTable;
